import { render, staticRenderFns } from "./TranscriptionInWordPreview.vue?vue&type=template&id=82b72906&lang=pug&"
import script from "./TranscriptionInWordPreview.vue?vue&type=script&lang=js&"
export * from "./TranscriptionInWordPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports